import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'NumberFormat',
})
export class NumberFormatPipe implements PipeTransform {

    constructor(
        @Inject(LOCALE_ID) private locale: string,
    ) { }

    transform(value: number, format?: string): string | null {
        if (isEmpty(value)) {
            value = 0;
        }

        if (isEmpty(format)) {
            format = '1.2-6';
        }

        try {
            return formatNumber(value, this.locale, format);
        } catch (error) { }
    }
}

function isEmpty(value: any): boolean {
    return value == null || value === '' || value !== value;
}
